export const AUTH_API = `auth-service/api/auth`;
